import React from 'react'
import PropTypes from 'prop-types'
import AddConversationView from '../component/AddConversationView'

const AddConversation = props => {
  return <AddConversationView {...props} />
}

AddConversation.propTypes = {
  onClick: PropTypes.func,
}

export default AddConversation
